var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_magnifier"},[_c('img',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height},on:{"mouseover":_vm.handOver,"mousemove":_vm.handMove,"mouseout":_vm.handOut}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-11907a96","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/imgZoom.vue
// module id = 20
// module chunks = 0